// extracted by mini-css-extract-plugin
export default {"noResult":"sav_wJT","noResultIcon":"WQjmEKX","noResultHeading":"uHhyn7_","noResultText":"vntZCgs","noResultButton":"mYeG6So"};